import React from 'react';
// Mui
import { Box, CircularProgress, Typography } from '@mui/material';

export const Loader:React.FC = () => {
  return (
    <Box textAlign="center"><CircularProgress /></Box>
  )
}

type NoDataTexProps = {
  text?: string;
}

export const NoDataText:React.FC<NoDataTexProps> = ({
  text = 'No item(s)'
}) => {
  return (
    <Box textAlign="center">
      <Typography variant="body2">{text}</Typography>
    </Box>
  )
}

export const NoData:React.FC = () => {
  return (
    <Box sx={{
      width: '100%', padding: '48px 32px 72px', backgroundColor: '#e8eced', borderRadius: '8px', mt: 2,
      display: 'flex', flexDirection: 'column', justifyContent: 'cetner', alignItems: 'center', gap: 2
    }}>
      <img src="/img/icons/noData.svg" alt="" />
      <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontWeight: 500, textAlign: 'center' }}>No data to display</Typography>
    </Box>
  );
}

export const NoSearchData:React.FC = () => {
  return (
    <Box sx={{
      width: '100%', padding: '48px 32px 72px', backgroundColor: '#e8eced', borderRadius: '8px',
      display: 'flex', flexDirection: 'column', justifyContent: 'cetner', alignItems: 'center', gap: 2
    }}>
      <img src="/img/icons/noSearchData.svg" alt="" />
      <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontWeight: 500, textAlign: 'center' }}>No data matching your search or filter criteria</Typography>
    </Box>
  );
}

export const NoNotifications:React.FC = () => {
  return (
    <Box sx={{
      width: '100%', height: '100%', padding: '48px 32px 72px', backgroundColor: '#e8eced', borderRadius: '8px', mt: 2,
      display: 'flex', flexDirection: 'column', justifyContent: 'cetner', alignItems: 'center', gap: 2
    }}>
      <img src="/img/icons/noNotifications.svg" alt="" />
      <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontWeight: 500, textAlign: 'center' }}>No new notifications</Typography>
    </Box>
  );
}

export const NoChats:React.FC = () => {
  return (
    <Box sx={{
      width: '100%', height: '100%', padding: '48px 32px 72px', backgroundColor: '#e8eced', borderRadius: '8px', mt: 2,
      display: 'flex', flexDirection: 'column', justifyContent: 'cetner', alignItems: 'center', gap: 2
    }}>
      <img src="/img/chats.png" alt="" style={{ height: '100px', maxWidth: '100%', objectFit: 'contain' }} />
      <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontWeight: 500, textAlign: 'center', pt: 2 }}>You don’t have any active chats</Typography>
    </Box>
  );
}
